import React from 'react'
import { useState, useEffect } from 'react';
import TableComponent from "../../../Common/TableComponent/tableComponent";
import { getTransactionReport } from '../../../Apis/transactionReportApi';
import { AllVehicleTypeDetails } from '../../../Apis/vehicleApi';
import { useForm } from 'react-hook-form';

const TransacationReport = () => {
    const headers = [
        "zone",
        "circle",
        "ward",
        "containerUuid",
        "isDeviatedFromTransferStation",
        "isOpenCollection",
        "isTertiaryTransaction",
        "scannedLatitude",
        "scannedLongitude",
        "transferStationName",
        "transferStationInchargeName",
        "vehicleUUid",
        "isActive",
        "actions",
    ];
    const { register, handleSubmit, watch, reset, setValue, formState: { errors }, } = useForm();
    const [vehicleData, setVehicleData] = useState([])
    const [transactionReport, setTransactionReport] = useState([]);

    const fetchVehicleData = async () => {
        try {
            const response = await AllVehicleTypeDetails();
            setVehicleData(response);
            // console.log(response, 'vehicle response')
        } catch (error) {
            console.log(error)
        }
    }

    const searchTransactionReport = async (data) => {
        try {
            const FromDate = data.FromDate || "";
            const ToDate = data.ToDate || "";
            const VehicleTypeid = data.VehicleTypeid || "";
            const requestData = {
                FromDate,
                ToDate,
                VehicleTypeid
            }
            const res = await getTransactionReport(requestData);
            // console.log(res, 'res from transaction report')
            const transactionResponse = res.data.map(zoneData => ({
                ...zoneData,
                zone: zoneData.zoneName,
                circle: zoneData.circleName,
                ward: zoneData.wardName,
            }));
            // setgetZoneReport(res.data)
            setTransactionReport(transactionResponse)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchVehicleData();
    }, [])

    const handleKeyDown = (event, callback) => {
        if (event.key === "Enter" && event.shiftKey === false) {
            event.preventDefault();
            callback(searchTransactionReport);
        }
    };

    return (
        <div style={{ width: "100%" }}>
            <div className="content">
                <div className="page-content">
                    <div className="page-header"></div>
                    <div className="row">
                        <div className="col" >
                            <div className="container-fluid pt-3">
                                <div className="row mb-5">
                                    <div className="col-xl-12 col-md-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <form onSubmit={handleSubmit(searchTransactionReport)}
                                                    onKeyDown={(e) => {
                                                        handleKeyDown(e, handleSubmit);
                                                    }}>
                                                    <div class="row mt-5" style={{ textAlign: "justify" }}>
                                                        <div class="col-md-3 mb-2">
                                                            <label htmlFor="FromDate"> From Date:</label>
                                                            <input
                                                                type="date"
                                                                name='FromDate'
                                                                id="FromDate"
                                                                {...register('FromDate')}
                                                                style={{ backgroundColor: "#fff" }}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div class="col-md-3 mb-2">
                                                            <label htmlFor="ToDate"> To Date:</label>
                                                            <input
                                                                type="date"
                                                                id="ToDate"
                                                                name="ToDate"
                                                                {...register('ToDate')}
                                                                style={{ backgroundColor: "#fff" }}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div class="col-md-3 mb-3">
                                                            <label htmlFor="VehicleTypeid">Vehicle Type</label>
                                                            <select
                                                                className="form-select"
                                                                style={{ backgroundColor: "#fff" }}
                                                                name="VehicleTypeid"
                                                                id="VehicleTypeid"
                                                                {...register("VehicleTypeid")}
                                                            >
                                                                <option value="">--select--</option>
                                                                {/* {console.log(vehicleData, 'vehicleData')} */}
                                                                {vehicleData.map((vehicle) => (
                                                                    <option value={vehicle.vehicleTypeId}>{vehicle.vehicleTypeName}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div class="col-md-3 mt-4">
                                                            <button type="submit" className='btn btn-danger'>Search</button>
                                                        </div>
                                                    </div>
                                                </form>
                                                <TableComponent
                                                    DataFetchURL={transactionReport}
                                                    headers={headers}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default TransacationReport;
